import { ViewContainerRef, ElementRef, Input, Directive, inject } from '@angular/core';
import { SatPopoverComponent } from '@ncstate/sat-popover';

@Directive({
  standalone: true,
  selector: '[vshcDynamicPopAnchor]',
  exportAs: 'dynamicPopAnchor'
})
export class DynamicPopAnchorDirective {

  #viewContainerRef = inject(ViewContainerRef);
  #elementRef = inject(ElementRef);

  @Input()
  vshcDynamicPopAnchor: SatPopoverComponent;

  open(callOpen = true, anchor?: HTMLElement | ElementRef<HTMLElement>) {
    if (this.vshcDynamicPopAnchor) {
      this.vshcDynamicPopAnchor.setCustomAnchor(
        this.#viewContainerRef,
        anchor ? anchor : this.#elementRef
      );

      if (callOpen) {
        this.vshcDynamicPopAnchor.open();
      }
    }
  }

  anchor(anchor?: HTMLElement | ElementRef<HTMLElement>) {
    if (this.vshcDynamicPopAnchor) {
      this.vshcDynamicPopAnchor.setCustomAnchor(
        this.#viewContainerRef,
        anchor ? anchor : this.#elementRef
      );
    }
  }

  close() {
    if (this.vshcDynamicPopAnchor) {
      this.vshcDynamicPopAnchor.close();
    }
  }

  toggle(): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.vshcDynamicPopAnchor.isOpen() ? this.close() : this.open();
  }
}
